import { Card } from '@agro1desenvolvimento/react-components';
import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { PropsWithChildren } from 'react';
import { Propriedade } from '../../../@types';

export const gridSizes = 'col-12 sm:col-6 lg:col-4 xl:col-3';

interface PropriedadeCardPropsType {
  title: React.ReactNode;
  footer: React.ReactNode;
}

export const PropriedadeCard: React.FC<
  PropsWithChildren<PropriedadeCardPropsType>
> = ({ footer, title, children }) => (
  <div className={gridSizes}>
    <div className="p-2 card-container">
      <Card title={title} footer={footer}>
        {children}
      </Card>
    </div>
  </div>
);

interface CardTitleProps {
  propriedade: Propriedade;
  naoLidas?: number;
  onNotificacoesClick?: (target: HTMLElement) => void;
}

export const CardTitle: React.FC<CardTitleProps> = ({
  propriedade,
  naoLidas,
  onNotificacoesClick,
}) => (
  <div className="card-title-row">
    <span className="card-title-text">
      <span className="mr-1">{propriedade.descricao}</span>
      <span className="font-normal">
        (
        {formatNumber(propriedade.areaTotal, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}{' '}
        ha)
      </span>
    </span>
    {onNotificacoesClick && (
      <button
        type="button"
        className="card-notificacoes-btn"
        onClick={(event) => onNotificacoesClick(event.currentTarget)}
      >
        <span className="card-notificacoes-icon-wrapper">
          <i className="pi pi-bell" />
          {naoLidas !== undefined && naoLidas > 0 && (
            <span className="card-notificacoes-badge">{naoLidas}</span>
          )}
        </span>
      </button>
    )}
  </div>
);
